import { useCallback, useContext } from 'react';

import { useForm } from './useForm';
import { useFields } from './useFields';
import { ChangeFormContext } from '../store/context';

export const useGetFormFieldValue = () => {
    const { formName } = useContext(ChangeFormContext);
    const formConfig = useForm({ formName });
    const fields = useFields({ formConfig });

    return useCallback((imsField: string, formValues: {[key: string]: string}): string | null => {
        if (!fields) {
            return null;
        }

        const currentField = fields.find((field) => field.imsField === imsField);

        return currentField?.name ? formValues[currentField.name] : null;
    }, [fields]);
};
